import React, { useState } from "react";

import PropTypes from "prop-types";
import "./style.scss";
import {useTranslation} from "react-i18next";
import {NAME_SPACES} from "../../../locals/constants";

const FloatLabel = ({
  children,
  value,
  errors,
  required,
  touched,
  ...rest
}) => {
  const { t } = useTranslation(NAME_SPACES.GLOBAL);
  const [focus, setFocus] = useState(false);
  let { label } = rest;
  const labelClass =
    focus || (value && value.length !== 0) ? "label label-float" : "label";

  if (required) {
    label = `${label}`+' ('+t('REQUIRED')+')';
  }

  const isOccupied = focus || (value && value.length !== 0);

  return (
    <div
      className={`float-label-select ${errors && touched && "error-label"}`}
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}>
      {children}
      <label className={labelClass}>{label}</label>
      <small className={"input-errors"}>{errors}</small>
      {errors && isOccupied && (
        <small className={"input-errors"}>{errors}</small>
      )}
    </div>
  );
};

FloatLabel.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  value: PropTypes.array,
  errors: PropTypes.string,
  touched: PropTypes.bool,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default FloatLabel;
